
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/assessment/search",
      function () {
        return require("private-next-pages/assessment/search/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/assessment/search"])
      });
    }
  